import { render, staticRenderFns } from "./BaoCaoLoiNhuanChuaPhanPhoiCaNam.vue?vue&type=template&id=7880748b&scoped=true"
import script from "./BaoCaoLoiNhuanChuaPhanPhoiCaNam.vue?vue&type=script&lang=js"
export * from "./BaoCaoLoiNhuanChuaPhanPhoiCaNam.vue?vue&type=script&lang=js"
import style0 from "./BaoCaoLoiNhuanChuaPhanPhoiCaNam.vue?vue&type=style&index=0&id=7880748b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880748b",
  null
  
)

export default component.exports